// extracted by mini-css-extract-plugin
var _1 = "Divider-moduledivider__oz5q_";
export { _1 as "divider" }
